import { PortfolioProfile } from "../../../../../../shared/types/PortfolioProfile";
import { PortfolioSettingsModel } from "../../../../../portfolio-info/types/PortfolioSettingsModel";
import { ParameterType } from "../../../../../options-table/types/ParameterType";

class ChartDataSourceService {
    getDataSource = (
        portfolioProfile: PortfolioProfile,
        portfolioSettings: PortfolioSettingsModel,
        comparedPortfolioProfile: PortfolioProfile
    ): number[][] => {
        const dataSource: number[][] = [];

        dataSource.push(portfolioProfile.data.map(x => x.price));

        if (portfolioSettings.selectedOptionParameterType === ParameterType.Delta) {
            dataSource.push(portfolioProfile.data.map(x => x.currentDelta));
            dataSource.push(portfolioProfile.data.map(x => x.customDelta));
            dataSource.push(portfolioProfile.data.map(x => x.expirationDelta));

            if (portfolioSettings.useComparedPortfolio) {
                dataSource.push(comparedPortfolioProfile.data.map(x => x.customDelta));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.currentDelta));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.expirationDelta));
            }
        }

        if (portfolioSettings.selectedOptionParameterType === ParameterType.Gamma) {
            dataSource.push(portfolioProfile.data.map(x => x.currentGamma));
            dataSource.push(portfolioProfile.data.map(x => x.customGamma));
            dataSource.push(portfolioProfile.data.map(x => x.expirationGamma));

            if (portfolioSettings.useComparedPortfolio) {
                dataSource.push(comparedPortfolioProfile.data.map(x => x.customGamma));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.currentGamma));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.expirationGamma));
            }
        }

        if (portfolioSettings.selectedOptionParameterType === ParameterType.Vega) {
            dataSource.push(portfolioProfile.data.map(x => x.currentVega));
            dataSource.push(portfolioProfile.data.map(x => x.customVega));
            dataSource.push(portfolioProfile.data.map(x => x.expirationVega));

            if (portfolioSettings.useComparedPortfolio) {
                dataSource.push(comparedPortfolioProfile.data.map(x => x.currentVega));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.customVega));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.expirationVega));
            }
        }

        if (portfolioSettings.selectedOptionParameterType === ParameterType.Theta) {
            dataSource.push(portfolioProfile.data.map(x => x.currentTheta));
            dataSource.push(portfolioProfile.data.map(x => x.customTheta));
            dataSource.push(portfolioProfile.data.map(x => x.expirationTheta));

            if (portfolioSettings.useComparedPortfolio) {
                dataSource.push(comparedPortfolioProfile.data.map(x => x.currentTheta));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.customTheta));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.expirationTheta));
            }
        }

        if (portfolioSettings.selectedOptionParameterType === ParameterType.Rho) {
            dataSource.push(portfolioProfile.data.map(x => x.currentRho));
            dataSource.push(portfolioProfile.data.map(x => x.customRho));
            dataSource.push(portfolioProfile.data.map(x => x.expirationRho));

            if (portfolioSettings.useComparedPortfolio) {
                dataSource.push(comparedPortfolioProfile.data.map(x => x.currentRho));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.customRho));
                dataSource.push(comparedPortfolioProfile.data.map(x => x.expirationRho));
            }
        }

        return dataSource;
    }
}

export const chartDataSourceService = new ChartDataSourceService();